export default {
  path: '/referee',
  meta: {
    title: '绑定上级',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/is_referee`),
}



// WEBPACK FOOTER //
// ./src/views/changesj/router.js